<template>
    <div class="gallery-wrapper clearfix">
        <div v-if="!filtered">
            <div class="gallery-category" v-for="(category,index) in categories" v-bind:key="index" v-on:click="filterCategory(category, index)">
                <div class="gallery-category--rounded">
                    <div class="gallery-category__name" v-html="category.name"></div>
                    <img :src="category.teaser.path" :alt="category.teaser.name" />
                </div>
            </div>
        </div>
        <div class="gallery-wrapper" v-if="filtered">
            <h2 v-html="filteredCategory.name"></h2>
            <a class="back-link" v-on:click="resetFilter()">&lt;&lt; back to categories</a>
            <ul class="gallery clearfix" v-if="filteredImages.length > 0">
                <li class="gallery-image" v-for="(image,index) in filteredImages" v-bind:key="'image_' + index + '_' + image.id" v-on:click="show(image,index)">
                    <img :src="image.path" :alt="image.name" />
                </li>
            </ul>
            <div class="gallery-error" v-if="filteredImages.length == 0">currently no images uploaded</div>
            <a class="back-link" v-on:click="resetFilter()">&lt;&lt; back to categories</a>
        </div>
        <div class="show-image" v-if="showImage">
            <div class="show-image__close" v-on:click="closeShowImage()">✘</div>
            <div class="show-image__wrapper">
                <img :src="showImage.path" />
                <div class="show-image__name" v-html="showImage.name"></div>
                <div class="show-image__counter" v-html="'#'+showImage.id"></div>
                <div class="show-image__arrow show-image__arrow--left" v-on:click="previousImage()">&#5130;</div>
                <div class="show-image__arrow show-image__arrow--right" v-on:click="nextImage()">&#5125;</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Gallery',
        props: ['categories'],
        data: function () {
            return {
                currentIndex: 0,
                filtered: false,
                filteredImages: [],
                filteredCategory: null,
                showImage: ""
            }
        },
        mounted: function () {
        },
        computed: {
        },
        methods: {
            filterCategory: function (category) {
                this.filteredImages = category.images;
                this.filteredCategory = category;
                this.filtered = true;
            },
            resetFilter: function () {
                this.filtered = false;
                this.filteredCategory = null;
            },
            show: function (image, currentIndex) {
                this.showImage = image;
                this.currentIndex = currentIndex;
                document.getElementsByTagName("body")[0].classList.add('noscroll');
            },
            closeShowImage: function () {
                this.showImage = null;
                document.getElementsByTagName("body")[0].classList.remove('noscroll');
            },
            nextImage: function () {
                this.currentIndex++;
                if (this.currentIndex < this.filteredCategory.images.length) {
                    this.showImage = this.filteredCategory.images[this.currentIndex];
                }
                else {
                    this.currentIndex = 0;
                    this.showImage = this.filteredCategory.images[this.currentIndex];
                }
            },
            previousImage: function () {
                this.currentIndex--;
                if (this.currentIndex >= 0) {
                    this.showImage = this.filteredCategory.images[this.currentIndex];
                }
                else {
                    this.currentIndex = this.filteredCategory.images.length - 1;
                    this.showImage = this.filteredCategory.images[this.currentIndex];
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2 {
        font-size: 40px;
    }

    .back-link {
        cursor: pointer;
        font-size: 20px;
        font-weight: bold;
        display: inline-block;
        margin: 20px 0;
    }

    .gallery {
        list-style: none;
        margin: 0 -5px;
        padding: 0;
    }

    .gallery-image {
        float: left;
        width: 25%;
        cursor: pointer;
        opacity: 1;
        padding: 10px;
        transition: transform ease-in-out 100ms;
        overflow: hidden;
        display: block;
    }

        .gallery-image img {
            transition: border ease-in-out 100ms;
            border: 8px solid rgba(255,255,255,0);
        }

        .gallery-image:hover img {
            border: 8px solid rgba(255,255,255,1);
        }

    @media screen and (max-width: 1024px) {
        .gallery-image {
            width: 50%;
            padding: 10px;
        }
    }

    @media screen and (max-width: 768px) {
        .gallery-image {
            width: 100%;
            padding: 10px;
        }
    }

    .gallery-image:hover {
        opacity: 1;
        transform: scale(1.1);
    }

    .gallery-image img {
        width: 100%;
        height: auto;
    }

    @media (orientation: landscape) {
        .gallery-category {
            width: 33.333%;
        }
    }

    .gallery-category {
        width: 33.333%;
        padding: 20px;
        transition: 200ms ease-in-out all;
        float: left;
    }

        .gallery-category .gallery-category__name {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 1;
            font-weight: bold;
            text-shadow: 1px 1px 3px #000;
            font-size: 2.5vw;
            text-align: center;
            transition: 150ms ease-in-out all;
        }

        .gallery-category:hover {
            padding: 10px;
        }

            .gallery-category:hover .gallery-category__name {
                font-size: 3vw;
            }

    .gallery-category--rounded {
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        width: 100%;
        height: 100%;
        top: 0;
    }

    .gallery-category img {
        width: 100%;
        position: absolute;
        top: 0;
    }

    .gallery-category--rounded:before {
        content: "";
        display: block;
        width: 100%;
        padding-bottom: 100%;
        position: relative;
    }

    @media (orientation: portrait) {
        .gallery-category {
            width: 90%;
            margin-left: 5%;
            margin-right: 5%;
        }

            .gallery-category .gallery-category__name {
                font-size: 8vw;
            }

            .gallery-category:hover .gallery-category__name {
                font-size: 12vw;
            }
    }

    .show-image {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.9);
        z-index: 99;
        overflow: auto;
    }

    .show-image__wrapper {
        padding: 20px;
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .show-image__counter {
        text-align: right;
        font-size: 20px;
        font-weight: bold;
        margin-top: 10px;
        float: right;
    }

    .show-image__name {
        text-align: left;
        font-size: 20px;
        font-weight: normal;
        margin-top: 10px;
        float: left;
    }

    .show-image img {
        width: 100%;
        height: auto;
        display: block;
        position: relative;
    }

    @media (orientation: landscape) {
        .show-image .show-image__wrapper {
            width: 75%;
        }

        .show-image__arrow--left {
            left: -40px;
        }

        .show-image__arrow--right {
            right: -40px;
        }
    }

    @media (orientation: portrait) {
        .show-image .show-image__wrapper {
            width: 100%;
            padding-left: 60px;
            padding-right: 60px;
        }

        .show-image__arrow--left {
            left: 10px;
        }

        .show-image__arrow--right {
            right: 10px;
        }
    }

    .show-image__close {
        position: fixed;
        right: 20px;
        top: 0px;
        text-transform: uppercase;
        z-index: 100;
        font-weight: bold;
        font-size: 60px;
        text-shadow: 1px 1px 4px #fff;
        cursor: pointer;
        padding: 10px;
        background: #000;
        opacity: 1;
        height: 100px;
        line-height: 64px;
        text-align: center;
        transition: 100ms all;
        border: 8px solid #000;
    }

    .show-image__arrow {
        position: absolute;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        top: calc(50% - 29px);
        transform: translateY(-50%);
        font-weight: bold;
        font-size: 40px;
        cursor: pointer;
        user-select: none;
    }

    @media screen and (max-width: 1024px) {
        .show-image__close {
            height: 50px;
            font-size: 24px;
            line-height: 14px;
        }
    }

    .show-image__close:hover {
        background: white;
        color: black;
        border: 8px solid #000;
        text-shadow: 1px 1px 4px #000;
    }
</style>
